import {RootScope} from '../types/angular-types';
import * as _ from 'lodash-es';
import * as angular from 'angular';

angular.module('GorillaBoy.Login')
.controller('GenericErrorController', [
    '$scope',
    '$window',
    '$log',
    GenericErrorController
]);

function GenericErrorController ($scope, $window: Window, $log: angular.ILogService) {
    $scope.retryUrl = function () {
        $log.log("Taking the user to previous page");
        $window.history.go(-1);
    };
}
